import { FormHelperText, Stack, Typography } from '@mui/material';
import { useField } from 'formik';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { XmlEditor, XmlEditorVariant } from '../xml/xmlEditor';

export const XmlField = ({
  name,
  icon,
  intlLabelId,
  variant
}: {
  name: string;
  icon?: ReactNode;
  intlLabelId?: string;
  variant?: XmlEditorVariant;
}) => {
  const [field, meta, helpers] = useField(name);
  const intl = useIntl();
  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1} alignItems="center">
        {icon}
        {intlLabelId && (
          <Typography variant="caption" fontWeight="bold" lineHeight={1.2}>
            {intl.formatMessage({
              id: intlLabelId
            })}
          </Typography>
        )}
      </Stack>
      <XmlEditor
        onBlur={() => helpers.setTouched(true)}
        onChange={(value) => helpers.setValue(value)}
        value={field.value}
        variant={variant}
      />
      {meta.error && meta.touched && <FormHelperText error>{meta.error}</FormHelperText>}
    </Stack>
  );
};
